// extracted by mini-css-extract-plugin
export var dropdownContainer = "_5c-5";
export var imageContainer = "_5c-4";
export var metricsGrid = "_5c-2";
export var productDetailContainer = "_5c-1";
export var productListContainer = "_5c-0";
export var subscriberTableContainer = "_5c-3";